import { render, staticRenderFns } from "./t-dropdown.vue?vue&type=template&id=d9dfaa58&scoped=true"
import script from "./t-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-dropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./t-dropdown.vue?vue&type=style&index=0&id=d9dfaa58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dfaa58",
  null
  
)

export default component.exports